import { render, staticRenderFns } from "./UploadCsvButton.vue?vue&type=template&id=20f13fca&"
import script from "./UploadCsvButton.vue?vue&type=script&lang=js&"
export * from "./UploadCsvButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports